(function () {
  const PDP = {
    mainSwiper: null,
    thumbsSwiper: null,
    inited: false,

    log(...a){ try{ console.log('[PDP]', ...a);}catch(e){} },
    err(...a){ try{ console.error('[PDP]', ...a);}catch(e){} },

    qs(sel, root=document){ return root.querySelector(sel); },
    qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); },

    /**
     * Safe money formatting.
     * Uses Shopify.formatMoney with the store's configured format.
     * No manual string slicing that can corrupt 4-digit prices.
     */
    formatMoney(cents, opts = { trimTrailing00: false }) {
      // Prefer Shopify's official utilities if present
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        // Shopify.money_format is the shop's format string (e.g. "${{amount_with_comma_separator}}")
        const moneyFormat = (typeof Shopify.money_format === 'string' && Shopify.money_format.length)
          ? Shopify.money_format
          : '${{amount}}'; // ultra-safe fallback
        let out = Shopify.formatMoney(cents, moneyFormat);
        if (opts.trimTrailing00) {
          // Remove ONLY a trailing .00 or ,00 at the end of the string
          out = out.replace(/([.,])00\b/, '');
        }
        return out;
      }

      // Hard fallback (keeps decimals; locale groups thousands)
      const value = (Number(cents) / 100);
      try {
        const withDec = value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return opts.trimTrailing00 ? withDec.replace(/([.,])00\b/, '') : withDec;
      } catch(e) {
        // Absolute last resort
        const fixed = value.toFixed(2);
        return opts.trimTrailing00 ? fixed.replace(/([.,])00\b/, '') : fixed;
      }
    },

    findVariantById(id){
      const vs = (window.product && window.product.variants) || [];
      return vs.find(v => String(v.id) === String(id));
    },
    findVariantBySelected(selected){
      const vs = (window.product && window.product.variants) || [];
      const names = (window.product && window.product.options) || [];
      return vs.find(v => v.options.every((val, idx) => selected[names[idx]] === val));
    },
    getSelectedFromDOM(){
      const selected = {};
      this.qsa('.product-swatch input[type="radio"]:checked').forEach(inp => {
        const m = inp.name.match(/\[(.+)\]/);
        if (m) selected[m[1]] = inp.value;
      });
      return selected;
    },
    setSwatchUIForVariant(variant){
      if (!variant) return;
      const names = (window.product && window.product.options) || [];
      names.forEach((optName, idx) => {
        const val = variant.options[idx];
        const group = this.qs(`.product-option__values[data-option-name="${CSS.escape(optName)}"]`);
        if (!group) return;
        this.qsa('input[type="radio"]', group).forEach(inp => {
          const checked = inp.value === val;
          inp.checked = checked;
          const label = inp.closest('.product-swatch');
          if (label) label.classList.toggle('active', checked);
        });
      });
    },

    applyVariant(variant){
      if (!variant) return;
      const variantInput = this.qs('#variantId');
      const priceEl = this.qs('.product-price');
      const compareEl = this.qs('.product-compare');
      const addBtn = this.qs('#addToCart');

      if (variantInput) variantInput.value = variant.id;

      // Format prices robustly
      if (priceEl) {
        priceEl.textContent = this.formatMoney(variant.price, { trimTrailing00: false });
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = this.formatMoney(variant.compare_at_price, { trimTrailing00: false });
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          compareEl.textContent = '';
        }
      }

      if (addBtn) addBtn.disabled = !variant.available;

      // Update URL without reload
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch(e){ /* noop */ }

      // Jump gallery to featured_media
      if (this.mainSwiper && variant.featured_media && variant.featured_media.id) {
        const slides = this.qsa('.main-swiper .swiper-wrapper > .swiper-slide')
          .filter(sl => !sl.classList.contains('swiper-slide-duplicate'));
        const idx = slides.findIndex(sl => sl.getAttribute('data-media-id') === String(variant.featured_media.id));
        if (idx >= 0) this.mainSwiper.slideToLoop(idx);
      }
    },

    bindSwatches(){
      this.qsa('.product-swatch input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const selected = this.getSelectedFromDOM();
          const v = this.findVariantBySelected(selected);
          this.log('swatch change → variant', v && v.id);
          if (v) {
            this.qsa('.product-swatch').forEach(l => l.classList.remove('active'));
            this.setSwatchUIForVariant(v);
            this.applyVariant(v);
          }
        });
      });
    },

    bindAccordions(){
      const BTN = '.accordion-toggle';

      const setOpen = (btn, open) => {
        const content = btn && btn.nextElementSibling;
        if (!content) return;

        btn.setAttribute('aria-expanded', String(open));
        btn.classList.toggle('active', open);

        if (open) {
          content.style.maxHeight = '0px';
          // force reflow
          // eslint-disable-next-line no-unused-expressions
          content.offsetHeight;
          content.style.maxHeight = content.scrollHeight + 'px';
          setTimeout(() => {
            content.style.maxHeight = content.scrollHeight + 'px';
          }, 150);
        } else {
          content.style.maxHeight = '0px';
        }
      };

      this.qsa(BTN).forEach(btn => {
        if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');
        const open = btn.getAttribute('aria-expanded') === 'true';
        setOpen(btn, open);
      });

      document.addEventListener('click', (evt) => {
        const btn = evt.target.closest(BTN);
        if (!btn) return;

        evt.preventDefault();
        evt.stopPropagation();
        if (typeof evt.stopImmediatePropagation === 'function') {
          evt.stopImmediatePropagation();
        }

        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        setOpen(btn, !isOpen);
      }, true);

      this.qsa('.accordion-content img').forEach(img => {
        img.addEventListener('load', () => {
          const btn = img.closest('.product-accordion')?.querySelector(BTN);
          if (!btn) return;
          if (btn.getAttribute('aria-expanded') === 'true') {
            const content = btn.nextElementSibling;
            if (content) content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      });
    },

    bindQtyGuard(){
      this.qsa('.product-info__quantity-input').forEach(input => {
        input.addEventListener('change', () => {
          const val = parseInt(input.value, 10);
          if (isNaN(val) || val < 1) input.value = 1;
        });
      });
    },

    initSwipers(){
      if (!window.Swiper) return this.err('Swiper not found');

      // Thumbs: vertical, 3 visible, mousewheel scroll
      if (this.qs('.thumbs-swiper') && !this.thumbsSwiper) {
        this.thumbsSwiper = new Swiper('.thumbs-swiper', {
          direction: 'vertical',
          slidesPerView: 3,
          spaceBetween: 8,
          watchSlidesProgress: true,
          mousewheel: true,
          breakpoints: {
            0:   { direction: 'horizontal', slidesPerView: 4 },
            768: { direction: 'vertical',   slidesPerView: 3 }
          }
        });
      }

      // Main: custom arrows + synced with thumbs
      if (this.qs('.main-swiper') && !this.mainSwiper) {
        this.mainSwiper = new Swiper('.main-swiper', {
          loop: true,
          spaceBetween: 10,
          navigation: { nextEl: '.custom-next', prevEl: '.custom-prev' },
          thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined
        });
      }

      this.log('Swipers initialized');
    },

    initVariant(){
      const urlVar = (() => {
        try { return new URL(window.location.href).searchParams.get('variant'); }
        catch(e){ return null; }
      })();

      let v = urlVar ? this.findVariantById(urlVar) : null;

      if (!v) {
        const hidden = this.qs('#variantId');
        if (hidden && hidden.value) v = this.findVariantById(hidden.value);
      }
      if (!v) v = this.findVariantBySelected(this.getSelectedFromDOM());

      if (v) {
        this.setSwatchUIForVariant(v);
        this.applyVariant(v);
        this.log('Variant initialized', v.id);
      } else {
        this.err('No matching variant found on init');
      }
    },

    init(){
      if (this.inited) this.log('Re-init (safe)');
      this.inited = true;

      if (!window.product) return this.err('window.product missing');

      this.initSwipers();
      this.bindSwatches();
      this.bindAccordions();
      this.bindQtyGuard();
      this.initVariant();
    }
  };

  // Expose for manual debug
  window.PDP = PDP;

  // Fire when possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PDP.init());
  } else {
    PDP.init();
  }

  // For Shopify Theme Editor / dynamic reloads
  document.addEventListener('shopify:section:load', () => PDP.init());
  document.addEventListener('page:load', () => PDP.init());
})();
